import jsonExport from "jsonexport/dist";
import { downloadCSV, type Exporter } from "ra-core";

import { neutralizeCsvRow } from "@/lib/csvSafe";
import { toExpenseCsvRow } from "./expenseReportRules";
import type { Expense, ExpensePaidBy } from "./expenseTypes";

const PAYER_LABELS: Record<ExpensePaidBy, string> = {
  sibaris: "Sibaris",
  pepe_diaz: "Pepe Díaz",
  otro: "Otro",
};

/**
 * Almikia Epic EG (TASK-045): CSV of the Gastos list (`export_expenses()` path,
 * `meta.export`). Cancelled rows are included with a `cancelado` column and
 * the reason, so the file is auditable.
 */
export const expensesExporter: Exporter<Expense> = (records) => {
  const rows = records.map((expense) =>
    neutralizeCsvRow(
      toExpenseCsvRow(expense, (paidBy) => PAYER_LABELS[paidBy]),
    ),
  );
  return jsonExport(rows, {}, (error: unknown, csv: string) => {
    if (error) {
      console.error("expensesExporter.error", error);
      return;
    }
    downloadCSV(csv, "gastos");
  });
};
